import { useEffect, useState } from 'react';
import { URLProvider } from '../../../../../components/Booking-new/providers/dataProviders';

export function useCityStateUrl({ closestLocations, setClosestLocations }) {
  const [cityUrl, setCityUrl] = useState(null);
  const [stateUrl, setStateUrl] = useState(null);

  useEffect(() => {
    const URL = new URLProvider();
    if (URL.searchParams.city) setCityUrl(URL.searchParams.city);
    if (URL.searchParams.state) setStateUrl(URL.searchParams.state);
  }, []);

  // if there is any city or state given in the Url params
  useEffect(() => {
    if (cityUrl || stateUrl) {
      const city = cityUrl?.toLowerCase();
      const state = stateUrl?.toLowerCase();
      const urlLocations = closestLocations.filter(
        location =>
          location.city?.toLowerCase().includes(city) ||
          location.state?.toLowerCase().includes(state) ||
          location.name?.toLowerCase().includes(city || state),
      );
      setClosestLocations(urlLocations);
    }
  }, [cityUrl, stateUrl]);

  return {
    cityUrl,
    stateUrl,
  };
}
